import { render, staticRenderFns } from "./DiseasesActivity.vue?vue&type=template&id=61f734df&scoped=true"
import script from "./DiseasesActivity.vue?vue&type=script&lang=js"
export * from "./DiseasesActivity.vue?vue&type=script&lang=js"
import style0 from "./DiseasesActivity.vue?vue&type=style&index=0&id=61f734df&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f734df",
  null
  
)

export default component.exports